// src/layouts/MainLayout.js
import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import CookieConsent from '../components/common/CookieConsent';

const main = ({ children }) => {
  return (
    <div className="d-flex flex-column min-vh-100 bg-white">
      {/* Header */}
      <div className="py-3">
        <Header />
      </div>

      {/* Main content grows to fill space */}
      <main className="flex-fill">
        {children}
      </main>

      {/* Footer at bottom */}
      <div className="py-3">
        <Footer />
      </div>
      
      {/* Cookie Consent Banner */}
      <CookieConsent />
    </div>
  );
};

export default main;
